import { types, Instance, SnapshotOut } from "mobx-state-tree"

// Status display labels - German translations for UI
export const STATUS_LABELS: { [key: string]: string } = {
  // Special syncing status
  syncing: "Deine Anfrage wird an deine Prüfstelle vor Ort übermittelt",
  // Standard statuses
  new: "Auftrag übermittelt",
  confirmed: "Auftrag bestätigt",
  picking_up: "Fahrer unterwegs",
  at_hub: "Fahrzeug in Prüfung",
  ready_to_return: "Prüfung abgeschlossen",
  returning: "Rücktransport läuft",
  completed: "Rücktransport abgeschlossen",
  no_show: "Nicht angetroffen - Buche dir gerne einen neuen Termin oder melde dich bei uns",
  backlog: "Auftrag übermittelt",
  cancelled: "Storniert – Buche gern neu.",
  // Legacy/compatibility
  pickup_due: "Abholung fällig",
}

// Status descriptions for UI
export const STATUS_DESCRIPTIONS: { [key: string]: string } = {
  new: "Auftrag übermittelt",
  confirmed: "Auftrag vom Fahrer bestätigt",
  picking_up: "Fahrer unterwegs",
  at_hub: "Fahrzeug in Prüfung",
  ready_to_return: "Prüfung abgeschlossen",
  returning: "Fahrer auf dem Rückweg",
  completed: "Fahrzeug zurückgebracht",
  no_show: "Nicht angetroffen",
  backlog: "Auftrag übermittelt",
  cancelled: "Auftrag storniert",
}

// Status icons for UI
export const STATUS_ICONS: { [key: string]: string } = {
  new: "send",
  confirmed: "check-circle",
  picking_up: "truck",
  at_hub: "clipboard-check",
  ready_to_return: "check",
  returning: "truck-delivery",
  completed: "check-all",
  no_show: "account-off",
  backlog: "calendar-clock",
  cancelled: "cancel",
}

// Numeric phase mapping for progress bar (1-7)
export const STATUS_TO_NUMERIC_PHASE: { [key: string]: number } = {
  new: 1,
  confirmed: 2,
  pickup_due: 2,
  picking_up: 3,
  at_hub: 4,
  ready_to_return: 5,
  returning: 6,
  completed: 7,
  no_show: 1,
  backlog: 1,
  cancelled: 1,
}

// Driveby service status labels (simplified 2-phase system)
export const DRIVEBY_STATUS_LABELS: { [key: string]: string } = {
  new: "Termin gebucht",
  confirmed: "Termin gebucht",
  picking_up: "Termin gebucht",
  at_hub: "Termin gebucht",
  backlog: "Termin gebucht",
  pickup_due: "Termin gebucht",
  no_show: "Nicht angetroffen",
  cancelled: "Termin storniert",
  ready_to_return: "Prüfung durchgeführt",
  returning: "Prüfung durchgeführt",
  completed: "Prüfung durchgeführt",
}

// DEPRECATED: Order phases enum - replaced by string status
// export enum OrderPhase {
//   AUFTRAG_GESENDET = "AUFTRAG_GESENDET",
//   AUFTRAG_BESTAETIGT = "AUFTRAG_BESTAETIGT",
//   FAHRER_UNTERWEGS = "FAHRER_UNTERWEGS",
//   AUTO_IN_PRUEFUNG = "AUTO_IN_PRUEFUNG",
//   RUECKTRANSPORT_LAEUFT = "RUECKTRANSPORT_LAEUFT",
//   AUTO_GELIEFERT = "AUTO_GELIEFERT",
//   TERMIN_GEBUCHT = "TERMIN_GEBUCHT",
//   PRUEFUNG_DURCHGEFUEHRT = "PRUEFUNG_DURCHGEFUEHRT",
// }

// DEPRECATED: Legacy numeric phase mapping - no longer used
// export const OrderPhaseNumeric = {
//   1: OrderPhase.AUFTRAG_GESENDET,
//   2: OrderPhase.AUFTRAG_BESTAETIGT,
//   3: OrderPhase.FAHRER_UNTERWEGS,
//   4: OrderPhase.AUTO_IN_PRUEFUNG,
//   5: OrderPhase.RUECKTRANSPORT_LAEUFT,
//   6: OrderPhase.AUTO_GELIEFERT,
// }

// DEPRECATED: Get numeric phase value - no longer used
// export function getNumericPhase(phase: OrderPhase): number {
//   const phaseToNumeric: { [key: string]: number } = {
//     [OrderPhase.AUFTRAG_GESENDET]: 1,
//     [OrderPhase.AUFTRAG_BESTAETIGT]: 2,
//     [OrderPhase.FAHRER_UNTERWEGS]: 3,
//     [OrderPhase.AUTO_IN_PRUEFUNG]: 4,
//     [OrderPhase.RUECKTRANSPORT_LAEUFT]: 5,
//     [OrderPhase.AUTO_GELIEFERT]: 6,
//   }
//   return phaseToNumeric[phase] || 1
// }

// DEPRECATED: Phase metadata configuration - no longer used
// export const PHASE_CONFIG = [
//   {
//     id: OrderPhase.AUFTRAG_GESENDET,
//     numericId: 1,
//     label: "Auftrag gesendet",
//     description: "Ihre Bestellung wurde erfolgreich übermittelt",
//     icon: "send",
//     estimatedDuration: 5,
//   },
//   {
//     id: OrderPhase.AUFTRAG_BESTAETIGT,
//     numericId: 2,
//     label: "Auftrag bestätigt",
//     description: "Wir haben Ihren Auftrag bestätigt",
//     icon: "check-circle",
//     estimatedDuration: 10,
//   },
//   {
//     id: OrderPhase.FAHRER_UNTERWEGS,
//     numericId: 3,
//     label: "Fahrer unterwegs",
//     description: "Unser Fahrer ist auf dem Weg zu dir",
//     icon: "truck",
//     estimatedDuration: 30,
//   },
//   {
//     id: OrderPhase.AUTO_IN_PRUEFUNG,
//     numericId: 4,
//     label: "Auto in Prüfung",
//     description: "Ihr Fahrzeug wird gerade geprüft",
//     icon: "clipboard-check",
//     estimatedDuration: 120,
//   },
//   {
//     id: OrderPhase.RUECKTRANSPORT_LAEUFT,
//     numericId: 5,
//     label: "Rücktransport läuft",
//     description: "Ihr Fahrzeug ist auf dem Rückweg",
//     icon: "truck-delivery",
//     estimatedDuration: 30,
//   },
//   {
//     id: OrderPhase.AUTO_GELIEFERT,
//     numericId: 6,
//     label: "Auto geliefert",
//     description: "Ihr Fahrzeug wurde erfolgreich zurückgebracht",
//     icon: "check-all",
//     estimatedDuration: 0,
//   },
//   // Driveby phases
//   {
//     id: OrderPhase.TERMIN_GEBUCHT,
//     numericId: 1, // Maps to phase 1 for driveby
//     label: "Termin gebucht",
//     description: "Ihr Termin wurde erfolgreich gebucht",
//     icon: "event",
//     estimatedDuration: 0,
//   },
//   {
//     id: OrderPhase.PRUEFUNG_DURCHGEFUEHRT,
//     numericId: 2, // Maps to phase 2 for driveby
//     label: "Prüfung durchgeführt",
//     description: "Die Prüfung wurde erfolgreich durchgeführt",
//     icon: "check-all",
//     estimatedDuration: 0,
//   },
// ]

// Location model
export const LocationModel = types.model("Location", {
  latitude: types.number,
  longitude: types.number,
  timestamp: types.number,
  heading: types.optional(types.number, 0),
  speed: types.optional(types.number, 0),
  isReturn: types.optional(types.boolean, false), // Track if driver is returning
})

// Removed AddressModel - using hubLocation from backend instead

// Route model
export const RouteModel = types.model("Route", {
  polyline: types.string, // Encoded polyline
  distance: types.number, // meters
  duration: types.number, // seconds
  waypoints: types.array(LocationModel),
  lastUpdated: types.optional(types.Date, () => new Date()),
})

// Hub location model (from backend)
export const HubLocationModel = types.model("HubLocation", {
  name: types.string,
  address: types.string,
  latitude: types.number,
  longitude: types.number,
  mapsUrl: types.maybe(types.string),
})

// Customer location model (from backend) - doesn't include name field
export const CustomerLocationModel = types.model("CustomerLocation", {
  address: types.string,
  latitude: types.number,
  longitude: types.number,
})

// Removed VehicleInfoModel - numberPlate is now stored directly in Order

// Service type enum
export enum ServiceType {
  PICKUP_DELIVERY = "pickup_delivery",
  DRIVEBY = "driveby",
}

// DEPRECATED: Map backend status strings to frontend OrderPhase enum values
// Use string status directly instead
// export function mapBackendStatusToPhase(
//   backendStatus: string,
//   serviceType?: ServiceType,
// ): OrderPhase {
//   // ... implementation removed ...
// }

// Main Order model - matching backend PublicOrderTracking interface
export const OrderModel = types
  .model("Order", {
    // Core identifiers
    id: types.identifier,

    // Backend fields exactly as named
    numberPlate: types.optional(types.string, ""), // Masked: "B-XX 1234"
    customerName: types.string, // Masked: "John D."
    status: types.string,
    orderPhase: types.string,
    serviceType: types.enumeration<ServiceType>("ServiceType", Object.values(ServiceType)),

    // Driver information
    pickupDriverName: types.maybe(types.string), // Formatted as "FirstName L."
    returnDriverName: types.maybe(types.string), // Formatted as "FirstName L."

    // Hub location (pickup/return point)
    hubLocation: types.maybe(HubLocationModel),

    // Customer location (delivery point) - from backend
    customerLocation: types.maybe(CustomerLocationModel),

    // Current driver location (updated every 60s in Firestore)
    currentDriverLocation: types.maybe(LocationModel),

    // PDF report availability
    hasPdfReport: types.optional(types.boolean, false),
    inspectionPassed: types.maybe(types.boolean),

    // Reschedule link from HubSpot
    ticketRescheduling: types.maybe(types.string),

    // Cancellation link from HubSpot
    ticketCancellation: types.maybe(types.string),

    // Metadata
    trackingValid: types.optional(types.boolean, true),
    lastLocationUpdate: types.maybe(types.Date),
    updatedAt: types.Date,

    // Time fields from backend
    scheduledPickupTime: types.maybe(types.string), // ISO string from backend
    scheduledReturnTime: types.maybe(types.string), // ISO string from backend

    // Order source
    orderSource: types.maybe(types.string), // "b2c-website" | "b2c-website-carassist-tracking-rebook" | "fleethub" | "orbitcontrol"

    // Additional frontend-specific fields (not from backend)
    createdAt: types.optional(types.Date, () => new Date()),
    estimatedArrival: types.maybe(types.Date),
    liveEstimatedCompletionMinutes: types.maybe(types.number),
    // ISO timestamp of projected order completion. Written by the backend on
    // every plan persist + every Live ETA Pusher event during driving phases,
    // so this stays in lockstep with liveEstimatedCompletionMinutes.
    projectedCompletionAtLive: types.maybe(types.string),
    // ISO timestamp: predicted moment PA arrives at customer's door (ADR-0012).
    // HBS-only. Frozen once realisedPickupAt is set or status leaves picking_up.
    projectedPickupAtLive: types.maybe(types.string),
    // ISO timestamp: moment PA physically took vehicle possession (ADR-0011).
    // Populated via HubSpot webhook pipeline. HBS-only; absent on drivebys.
    realisedPickupAt: types.maybe(types.string),
    route: types.maybe(RouteModel),
  })
  .views((self) => ({
    get currentPhaseConfig() {
      // No longer used - phase config is deprecated
      return undefined
    },
    get numericStatus() {
      // Get numeric status for UI components that still use numbers
      if (self.serviceType === ServiceType.DRIVEBY) {
        // For driveby, map to 1 or 2
        // Phase 1: new, confirmed, picking_up, no_show, backlog, at_hub
        // Phase 2: ready_to_return, returning, completed
        if (
          self.status === "completed" ||
          self.status === "ready_to_return" ||
          self.status === "returning"
        ) {
          return 2
        }
        return 1
      }
      return STATUS_TO_NUMERIC_PHASE[self.status] || 1
    },
    get isDriverPhase() {
      return self.status === "picking_up" || self.status === "returning"
    },
    get isLiveTrackingPhase() {
      return self.status === "picking_up" || self.status === "returning"
    },
    get shouldShowDriver() {
      // Don't show driver in phases 1, 2, or 7
      return self.status !== "new" && self.status !== "confirmed" && self.status !== "completed"
    },
    get shouldShowStaticDriver() {
      // Show static driver at hub (phases 4 and 5)
      return self.status === "at_hub" || self.status === "ready_to_return"
    },
    get phaseLabel() {
      // Special handling for picking_up - show different text if driver is returning
      if (self.status === "picking_up" && this.isDriverReturning) {
        return "Fahrer auf dem Weg zur Prüfstelle"
      }
      // Special handling for driveby - use explicit status labels
      if (self.serviceType === ServiceType.DRIVEBY) {
        return DRIVEBY_STATUS_LABELS[self.status] || self.status
      }
      return STATUS_LABELS[self.status] || self.status
    },
    get phaseDescription() {
      // Special handling for picking_up - show different description if driver is returning
      if (self.status === "picking_up" && this.isDriverReturning) {
        return "Unser Fahrer ist auf dem Rückweg zum Prüfzentrum"
      }
      // Special handling for driveby
      if (self.serviceType === ServiceType.DRIVEBY) {
        // Phase 2: ready_to_return, returning, completed
        if (
          self.status === "completed" ||
          self.status === "ready_to_return" ||
          self.status === "returning"
        ) {
          return "Die Prüfung wurde erfolgreich durchgeführt"
        }
        // Phase 1: everything else including at_hub
        return "Ihr Termin wurde erfolgreich gebucht"
      }
      return STATUS_DESCRIPTIONS[self.status] || ""
    },
    get phaseIcon() {
      // Special handling for driveby
      if (self.serviceType === ServiceType.DRIVEBY) {
        // Phase 2: ready_to_return, returning, completed
        if (
          self.status === "completed" ||
          self.status === "ready_to_return" ||
          self.status === "returning"
        ) {
          return "check-all"
        }
        // Phase 1: everything else including at_hub
        return "calendar-clock"
      }
      return STATUS_ICONS[self.status] || "help-circle"
    },
    get isReturn() {
      // Check if driver is in return phase (actively returning)
      return self.status === "returning"
    },
    get isDriveby() {
      return self.serviceType === ServiceType.DRIVEBY
    },
    get isDriverReturning() {
      // Check if driver is currently returning (based on location data)
      return self.currentDriverLocation?.isReturn || false
    },
    // Compatibility getters for components that expect old field names
    get driverLocation() {
      return self.currentDriverLocation
    },
    get deliveryAddress() {
      // Map hubLocation to the expected deliveryAddress format
      if (self.customerLocation) {
        return {
          formatted: self.customerLocation.address,
          name: (self.customerLocation as any).name || self.customerName,
          latitude: self.customerLocation.latitude,
          longitude: self.customerLocation.longitude,
        }
      }
      return null
    },
    get pickupTime() {
      // Parse scheduled pickup time or use estimatedArrival as fallback
      if (self.scheduledPickupTime) {
        return new Date(self.scheduledPickupTime)
      }
      return self.estimatedArrival || null
    },
    get returnTime() {
      // Parse scheduled return time
      if (self.scheduledReturnTime) {
        return new Date(self.scheduledReturnTime)
      }
      return null
    },
  }))
  .actions((self) => ({
    updateStatus(newStatus: string) {
      self.status = newStatus
      self.orderPhase = newStatus // Keep in sync
      self.updatedAt = new Date()
    },
    updateDriverLocation(location: Instance<typeof LocationModel>) {
      // Create a new location object to ensure MobX detects the change
      self.currentDriverLocation = LocationModel.create({
        latitude: location.latitude,
        longitude: location.longitude,
        timestamp: location.timestamp,
        heading: location.heading || 0,
        speed: location.speed || 0,
        isReturn: location.isReturn || false,
      })
      self.lastLocationUpdate = new Date()
    },
    updateETA(eta: Date) {
      self.estimatedArrival = eta
    },
    updateLiveETA(
      liveMinutes: number | undefined,
      timestamp: number,
      projectedCompletionAtLive?: string,
      projectedPickupAtLive?: string,
    ) {
      // Pickup-only Pusher fan-outs (heartbeat / status-transition) omit
      // liveMinutes — that field semantically belongs to the return leg.
      // Skip the return-side recompute when it's absent so we never write
      // NaN into estimatedArrival, while still letting the pickup projection
      // flow through.
      if (liveMinutes != null) {
        self.liveEstimatedCompletionMinutes = liveMinutes
        self.estimatedArrival = new Date(timestamp + liveMinutes * 60_000)
      }
      if (projectedCompletionAtLive) {
        self.projectedCompletionAtLive = projectedCompletionAtLive
      }
      // ADR-0012 §5: only update when the field is present on the wire.
      // Absence means "no change" (post-pickup freeze or live_pickup_eta off).
      // Backend owns the freeze gate; client must not synthesise or clear.
      if (projectedPickupAtLive) {
        self.projectedPickupAtLive = projectedPickupAtLive
      }
    },
    /**
     * Apply a realised-pickup timestamp (PLA-25 Pusher PICKUP_REALIZED).
     * First-write-wins: silently skips when realisedPickupAt is already set,
     * matching the server-side invariant in markRealisedPickup.
     */
    updateRealisedPickup(realisedPickupAt: string) {
      if (!realisedPickupAt) return
      if (self.realisedPickupAt) return
      self.realisedPickupAt = realisedPickupAt
    },
    /**
     * Flip hasPdfReport, used by the PLA-111 Pusher REPORT_AVAILABLE handler.
     * The backend predicate (shouldBroadcastReportAvailable) ensures we only
     * receive this on a real false→true transition, so we don't need to guard
     * against re-flips here.
     */
    setHasPdfReport(value: boolean) {
      self.hasPdfReport = value
    },
    updateRoute(route: Instance<typeof RouteModel>) {
      self.route = route
    },
    updateFromBackend(backendData: any) {
      // Direct mapping from backend PublicOrderTracking format
      self.numberPlate = backendData.numberPlate
      self.customerName = backendData.customerName

      // Use backend status directly
      self.status = backendData.status || backendData.orderPhase || "new"
      self.orderPhase = self.status

      // Only update serviceType if a valid value is provided
      // This prevents the serviceType from becoming undefined and switching visual modes
      if (
        backendData.serviceType &&
        (backendData.serviceType === "pickup_delivery" || backendData.serviceType === "driveby")
      ) {
        // Only update if we don't have a serviceType yet
        if (!self.serviceType) {
          self.serviceType = backendData.serviceType
        } else if (
          self.serviceType === ServiceType.DRIVEBY &&
          backendData.serviceType === "pickup_delivery"
        ) {
          // Allow one-way upgrade from driveby to pickup_delivery
          // This fixes cases where order syncs early with wrong serviceType
          self.serviceType = backendData.serviceType
        }
        // All other serviceType changes are blocked (including pickup_delivery → driveby)
      } else if (!self.serviceType) {
        // Only set a default if we don't have a serviceType yet
        // Default to driveby (2-stage) as it's safer
        self.serviceType = ServiceType.DRIVEBY
      }
      // If serviceType is missing/undefined and we have an existing value, preserve it

      self.hasPdfReport = backendData.hasPdfReport || false

      self.inspectionPassed =
        backendData.inspectionPassed === null ? undefined : backendData.inspectionPassed

      // Update driver names if provided
      if (backendData.pickupDriverName) {
        self.pickupDriverName = backendData.pickupDriverName
      }

      if (backendData.returnDriverName) {
        self.returnDriverName = backendData.returnDriverName
      }

      // Update reschedule link if provided
      if (backendData.ticketRescheduling) {
        self.ticketRescheduling = backendData.ticketRescheduling
      }

      // Update cancellation link if provided
      if (backendData.ticketCancellation) {
        self.ticketCancellation = backendData.ticketCancellation
      }

      // Update order source
      if (backendData.orderSource) {
        self.orderSource = backendData.orderSource
      }

      self.trackingValid = backendData.trackingValid !== false

      // Map time fields
      self.scheduledPickupTime = backendData.scheduledPickupTime || undefined
      self.scheduledReturnTime = backendData.scheduledReturnTime || undefined

      // ETA fields from backend (may be null in the public sanitized payload)
      if (backendData.liveEstimatedCompletionMinutes != null) {
        self.liveEstimatedCompletionMinutes = backendData.liveEstimatedCompletionMinutes
      }
      if (backendData.projectedCompletionAtLive) {
        self.projectedCompletionAtLive = backendData.projectedCompletionAtLive
      }
      // ADR-0012: projected PA door-arrival. Absent until backend ships the
      // field — defensive guard keeps the existing `scheduledPickupTime`
      // fallback via selectPickupLabel.
      if (backendData.projectedPickupAtLive) {
        self.projectedPickupAtLive = backendData.projectedPickupAtLive
      }
      // ADR-0011: realised handover timestamp. First-write-wins on the server;
      // once set we also never clear it on the client.
      if (backendData.realisedPickupAt) {
        self.realisedPickupAt = backendData.realisedPickupAt
      }

      // Update location data
      if (backendData.hubLocation) {
        self.hubLocation = backendData.hubLocation
      }

      if (backendData.customerLocation) {
        self.customerLocation = backendData.customerLocation
      }

      if (backendData.currentDriverLocation) {
        self.currentDriverLocation = backendData.currentDriverLocation
      }

      if (backendData.lastLocationUpdate) {
        self.lastLocationUpdate = new Date(backendData.lastLocationUpdate)
      }

      self.updatedAt = new Date(backendData.updatedAt || Date.now())
    },
  }))

export interface Order extends Instance<typeof OrderModel> {}
export interface OrderSnapshot extends SnapshotOut<typeof OrderModel> {}
